import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var BannerBackgroundSwirlWrapper = /*#__PURE__*/ styled("div", {
    target: "e1j0zz9x0"
})("svg{position:absolute;bottom:0;left:0;right:0;}");
var BannerBackground = /*#__PURE__*/ styled("div", {
    target: "e1j0zz9x1"
})("background:linear-gradient(\n    103.44deg,#6ec2b7 3.17%,", Theme.Color.primary, " 100%\n  );background-repeat:no-repeat;box-shadow:0 -0.125rem 0.25rem rgb(0 0 0 / 20%);border-radius:0.5rem 0.5rem 0 0;height:13.375rem;position:relative;overflow:hidden;");
var BannerPromoText = /*#__PURE__*/ styled("p", {
    target: "e1j0zz9x2"
})("width:86%;margin:1rem auto 1.5rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.375rem;line-height:1.5;display:flex;align-items:center;text-align:center;position:relative;z-index:1;");
export { BannerBackground, BannerBackgroundSwirlWrapper, BannerPromoText };
